// extracted by mini-css-extract-plugin
export default {"container":"End1Qd","headerContainer":"NfMTYD","commentCount":"i8wK2V","text":"B0oDou","buttonContainer":"FgArLt","errorCode":"eknF2x"};